import { type FC, useState } from "react";
import { navigateWithDeferredDeepLink } from "@userFrontend/utils/deferredDeepLinks";
import { container } from "./styles.css";
import { Presentation } from "./Presentation";

type Props = {
  href: string;
  isLogin: boolean;
  src: string;
  alt: string;
  dummyImgPath: string;
};

export const WebToAppBanner: FC<Props> = ({ href, isLogin, src, alt, dummyImgPath }) => {
  const [tapped, setTapped] = useState(false);

  const handleClick = () => {
    if (!tapped) {
      setTapped(true);
      navigateWithDeferredDeepLink({ isLogin, href });
    }
  };

  return (
    <div className={container}>
      <Presentation
        href={href}
        src={src}
        alt={alt}
        dummyImgPath={dummyImgPath}
        onClick={handleClick}
      />
    </div>
  );
};
